export default __webpack_public_path__ + "static/media/2535.0fcf4441.png";